module.exports = "img/flags/IN.5066387.png";